const styles = theme => ({
  drawerTitle: {
    textAlign: 'center',
    paddingTop: 24,
    paddingBottom:24,
  },
  after: {
    zIndex: 9500,
  },
  listFull: {
    width: 'auto',
  },
  buttons: {
    paddingTop: 24,
    paddingBottom: 24,
    textAlign: 'center',
    alignItems: 'center',
  },
  cancel: {
    margin: 10,
    alignItems: 'center',
    textAlign: 'center',
  },
  whiteText: {
    margin: 10,
    color: 'white',
    width: 90,
    height:20,
    borderRadius:3,
    backgroundColor: 'rgba(88,157,42,1)',
    '&:hover': {
      background: 'rgba(88,157,42,0.8)',
    },
  },
  priorityWhite: {
    color: 'black',
    width: 90,
    height:20,
    borderRadius:3,
    backgroundColor: 'rgba(255, 255, 255, 1.0)',
  },
  priorityGreen: {
    margin: 10,
    color: 'white',
    width: 90,
    height:20,
    borderRadius:3,
    backgroundColor: 'rgba(234,166,165,1)',
    '&:hover': {
      background: 'rgba(234,166,165,0.8)',
    },
  },
  priorityLightGreen: {
    margin: 10,
    color: 'white',
    width: 90,
    height:20,
    borderRadius:3,
    backgroundColor: 'rgba(188,231,62,1)',
    '&:hover': {
      background: 'rgba(188,231,62,0.8)',
    },
  },
  priorityRed: {
    margin: 10,
    color: 'white',
    width: 90,
    height:20,
    borderRadius:3,
    backgroundColor: 'rgba(174,1,0,1)',
    '&:hover': {
      background: 'rgba(174,1,0,0.8)',
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/PrioritiesDrawer/styles.js